import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-edit-popup b-blue-background b-blue-background__opacity b-blue-background--fixed" }
const _hoisted_2 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_3 = { class: "h-font-22 h-mt-20 h-mb-0 h-text-center" }
const _hoisted_4 = { class: "b-edit-popup__aside" }
const _hoisted_5 = { class: "h-flex h-flex-center h-flex-dir-column h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      iconColor: "#BEC7D4",
      "max-width": "400px",
      width: "auto",
      title: "",
      allowBackgroundScrolling: true,
      showClosePopup: true,
      popupBackground: "#F8F9FA",
      popupRadius: "20px",
      heightValue: "100%",
      onClose: _ctx.closePopup
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('ADD.RESERVED.SLOT.POPUP.EDIT.TITLE')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t(`ADD.RESERVED.SLOT.POPUP.EDIT.ASIDE`)) + " ", 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t(`ADD.RESERVED.SLOT.POPUP.EDIT.ASIDE.2`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FwButton, {
            class: "h-mt-10 h-width-100p qa-remove-future",
            paddingHorizontal: true,
            disabled: _ctx.instance.full_day,
            borderRadiusType: "small-border",
            onClick: _ctx.tryEditFuture
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`ADD.RESERVED.SLOT.POPUP.EDIT.AFTER`)) + " " + _toDisplayString(_ctx.date), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_FwButton, {
            class: "h-mt-10 h-width-100p qa-remove",
            borderRadiusType: "small-border",
            paddingHorizontal: true,
            disabled: _ctx.isRequestSending,
            onClick: _ctx.editAllSlots
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`ADD.RESERVED.SLOT.POPUP.EDIT.ALL`)), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("div", {
            class: "b-edit-popup__edit h-mt-20",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
          }, _toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
        ])
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
}